import { Button, InputNumber, Modal } from 'antd'
import { useUserContext } from 'common/context/UserContext'
import React, { useEffect, useState } from 'react'

interface AddFundsModalProps {
  open: boolean
  loading: boolean
  onCancel: () => void
  onSubmit: (amount: number) => void
}

const StripeLogo = () => (
  <svg aria-label="Stripe" role="img" viewBox="0 0 72 30" style={{ width: 56, height: 24, marginRight: 8 }}>
    <text x="0" y="22" fill="#635bff" fontFamily="Arial, sans-serif" fontSize="23" fontWeight="700">
      stripe
    </text>
  </svg>
)

const PaymentCardLogos = () => (
  <div aria-label="Supported payment cards" style={{ display: 'flex', alignItems: 'center', gap: 8, height: 28 }}>
    <span style={{ color: '#1434cb', fontSize: 17, fontWeight: 800, fontStyle: 'italic' }}>VISA</span>
    <span aria-label="Mastercard" style={{ display: 'inline-flex', width: 34, height: 21, position: 'relative' }}>
      <span style={{ width: 21, height: 21, borderRadius: '50%', background: '#eb001b', position: 'absolute', left: 0 }} />
      <span style={{ width: 21, height: 21, borderRadius: '50%', background: '#f79e1b', position: 'absolute', right: 0, opacity: 0.9 }} />
    </span>
    <span style={{ color: '#fff', background: '#2e77bc', borderRadius: 3, padding: '3px 5px', fontSize: 10, fontWeight: 700 }}>
      AMEX
    </span>
    <span style={{ color: '#111', border: '1px solid #d9d9d9', borderRadius: 3, padding: '3px 5px', fontSize: 10, fontWeight: 700 }}>
      DISCOVER
    </span>
  </div>
)

export const AddFundsModal: React.FC<AddFundsModalProps> = ({ open, loading, onCancel, onSubmit }) => {
  const [amount, setAmount] = useState<number | null>(null)
  const { colorPalette } = useUserContext()
  const validAmount = amount !== null && amount >= 1 && amount <= 10000

  useEffect(() => {
    if (!open) setAmount(null)
  }, [open])

  return (
    <Modal
      title={<span style={{ fontSize: 20, fontWeight: 700 }}>Add Funds</span>}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={450}
      destroyOnHidden
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, paddingTop: 8 }}>
        <div style={{ fontSize: 14, lineHeight: 1.2 }}>Enter Amount</div>
        <div style={{ border: '1px solid gray', borderRadius: 8, height: 36, display: 'flex', alignItems: 'center' }}>
          <InputNumber
            value={amount ?? undefined}
            onChange={(value) => setAmount(typeof value === 'number' ? value : null)}
            min={1}
            max={10000}
            step={0.01}
            precision={2}
            controls={false}
            prefix={<span style={{ color: colorPalette['--color-grey-2'] }}>$</span>}
            placeholder="0.00"
            style={{ flex: 1, border: 'none', fontSize: 18 }}
          />
          <StripeLogo />
        </div>
        <PaymentCardLogos />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
          <Button onClick={onCancel}>Cancel</Button>
          <Button type="primary" onClick={() => validAmount && onSubmit(amount)} loading={loading} disabled={!validAmount}>
            Add Funds
          </Button>
        </div>
      </div>
    </Modal>
  )
}
